import { formatForeignName, formatName } from '@/utils';
import React from 'react';

function renderUncommonWord(text) {
  return <span className="mocaofont">{text}</span>;
}

const getNum = (tele: string): string => {
  if (tele === null || tele === undefined) return '';
  const reg = /^\+(86|853|852|886)/;
  if (reg.exec(tele)) {
    return tele.replace(reg, '($1)');
  }
  return `(853)${tele}`;
};

export const infoList: {
  key:
    | 'namePt'
    | 'nameCn'
    | 'identityType'
    | 'identityNo'
    | 'informLanguage'
    | 'mobile';
  text: string;
  render?: (v) => React.ReactNode;
  renderKey?: (v, record) => React.ReactNode;
}[][] = [
  [
    {
      key: 'nameCn',
      text: '姓',
      render: (text) => {
        const [t] = formatName(text);
        return renderUncommonWord(t);
      },
    },
    {
      key: 'namePt',
      text: ' ',
      renderKey: (text) => {
        const [t] = formatForeignName(text);
        return t ? ' ' : '姓';
      },
      render: (text) => {
        const [t] = formatForeignName(text);
        return t;
      },
    },
    {
      key: 'nameCn',
      text: '名',
      render: (text) => {
        const [_, t] = formatName(text);
        return renderUncommonWord(t);
      },
    },
    {
      key: 'namePt',
      text: ' ',
      renderKey: (text) => {
        const [_, t] = formatForeignName(text);
        return t ? ' ' : '名';
      },
      render: (text) => {
        const [_, t] = formatForeignName(text);
        return t;
      },
    },
  ],
  [
    {
      key: 'identityType',
      text: '證件類型',
    },
    {
      key: 'identityNo',
      text: '證件號碼',
    },
    {
      key: 'mobile',
      text: '流動電話號碼',
      render: getNum,
    },
  ],
];
